import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const StyledContainer = styled(FlexColumn, {
  width: '100%',
})

export const ScriptContent = styled('div', ({ $theme }) => ({
  ...$theme.typography.ParagraphSmall,
  color: $theme.colors.contentPrimary,
  lineHeight: '1.5',
  maxHeight: '60vh',
  overflowY: 'auto',
  overflowWrap: 'anywhere',
  ':first-child > :first-child': {
    marginTop: 0,
  },
}))

export const EmptyText = styled('p', ({ $theme }) => ({
  ...$theme.typography.ParagraphSmall,
  color: $theme.colors.contentSecondary,
  margin: 0,
}))
